import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import { MdCheckCircleOutline } from "react-icons/md";
import { HiDocumentDownload } from "react-icons/hi";
import Header from "../header";
import { Link } from "@mui/material";
import Footer from "../footer";
import { DEFAULT_NOTICES } from "./circular_constant.js";

const CircularCard = ({ name, link }) => {
  return (
    <Box
      sx={{
        height: 220, // Increased card size
        width: 220, // Increased card size
        boxShadow: 5,
        borderRadius: 2,
        p: 1.5,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        marginBottom: 20,
        margin: 5,
      }}
    >
      <Box sx={{ display: "flex", gap: 4, justifyContent: "center" }}>
        <Box height="50" width="90">
          <MdCheckCircleOutline size="30px" color="green" />
        </Box>
        <Typography variant="h5">{name}</Typography>
        <Box height="50" width="90">
          <HiDocumentDownload size="40px" color="green" />
        </Box>
      </Box>
      <Box>
        {link && (
          <a href={link} target="_blank" rel="noreferrer">
            <Typography variant="subtitle1">Download</Typography>
          </a>
        )}
      </Box>
    </Box>
  );
};

export default function CircularPage() {
  const links = ["2024-2025", "2025-2026", "2026-2027"];
  const [active, setActive] = useState("2023-2024");

  var link23 = [
    { name: "C05 : Notification of the Day", link: "assets/dummy.pdf" },
    { name: "C03 : Notification of the Day", link: "assets/dummy.pdf" },
    { name: "C04 : Notification of the Day", link: "assets/dummy.pdf" },
  ];



  return (
    <>
      <div>
        <Header />
        <div>
          <div className="rbt-banner-area rbt-banner-2 header-transperent-spacer">
            <div className="wrapper">
              <Container>
                <Box
                  sx={{ pt: "40px", display: "flex", justifyContent: "center" }}
                >
                  <div className="rbt-new-badge rbt-new-badge-one mb--30">
                    <span className="rbt-new-badge-icon">🏆</span> The Leader in
                    Jharkhand
                  </div>
                </Box>
                <Typography variant="h2" align="center" gutterBottom>
                  Circular and Notices
                </Typography>
              </Container>
            </div>
          </div>
        </div>
        {/* End Banner Area */}
        <br />
        <Container>
          <Box display="flex" justifyContent="center">
            <ul
              className="nav nav-tabs tab-button-style-2"
              id="myTab-10"
              role="tablist"
            >
              {links.map((link, index) => (
                <li role="presentation" key={index}>
                  <a
                    href="#"
                    className={`tab-button${active === link ? " active" : ""}`}
                    id="home-tab-4"
                    data-bs-toggle="tab"
                    data-bs-target="#home-4"
                    role="tab"
                    aria-controls="home"
                    aria-selected="false"
                    onClick={() => setActive(link)}
                  >
                    <span className="title">{link}</span>
                  </a>
                </li>
              ))}
            </ul>
          </Box>
          <Box display="flex" justifyContent="center" flexWrap="wrap" mt={4}>
            {/* {link23.map((e, id) => (
              <div
                key={id}
                className={`tab-pane fade${active ? " active show" : ""}`}
                id={id}
                role="tabpanel"
                aria-labelledby="home-tab-4"
              >
                <CircularCard name={e.name} link={e.link} />
              </div>
            ))} */}
            {DEFAULT_NOTICES.map((items, index) => (
              <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                <div
                  key={index}
                  className="rbt-card card-list-2 event-list-card variation-01 rbt-hover"
                >
                  <div className="rbt-card-body">
                    <ul className="rbt-meta">
                      <li key={index}>
                        <i className="feather-calendar" />
                        {items.startDate}
                      </li>
                      {/* <li>
                        <i className="feather-map-pin" />
                        {items.location}
                      </li> */}
                    </ul>

                    <h4 className="rbt-card-title">
                      <h4>{items.name}</h4>
                      {/* <a href="event-details.html">{items.eventName}</a> */}
                    </h4>
                    <div className="read-more-btn">
                      <a
                        className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round"
                        href={items.link}
                        target="_blank"
                      >
                        <span className="icon-reverse-wrapper">
                          <span className="btn-text">Download</span>
                          <span className="btn-icon">
                            <i className="feather-arrow-right" />
                          </span>
                          <span className="btn-icon">
                            <i className="feather-arrow-right" />
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Box>
        </Container>
        <Box sx={{ pb: "30px" }}></Box>

        <Footer />
      </div>
    </>
  );
}
